<template>
  <v-dialog v-model="dialog.show" max-width="400" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <SelectTemperatura @onChanged="termometro = $event" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="save()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vendedor } from "@/services/lead";

export default {
  name: "DialogUpdatetermometro",

  components: {
    SelectTemperatura: () => import("@/components/select/SelectTemperatura")
  },

  data() {
    return {
      dialog: {
        show: false,
        title: "Atualizar Termometro"
      },
      termometro: "",
      lead: null,
      serviceLeadsVendedor: new Vendedor()
    };
  },

  methods: {
    show(lead) {
      this.lead = { ...lead };
      this.dialog.show = true;
    },

    async save() {
      try {
        if (this.$refs.form.validate()) {
          this.lead.termometro = this.termometro;
          await this.serviceLeadsVendedor.update({ ...this.lead });
          this.$emit("updated", { ...this.lead });
          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    close() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.dialog.show = false;
    }
  }
};
</script>
